import React from "react";
import FilterState from "./FilterState";
import TableErrorState from "./TableErrorState";
import HeaderState from "./HeaderState";
import Placeholder from "react-bootstrap/Placeholder";

import { Row, Col, Stack, Table } from "react-bootstrap";
import styles from "./states.module.css";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import BarGraphErrorStates from "./BarGraphErrorStates";

const CustomYAxisTick = ({ x, y, payload }) => (
  <g transform={`translate(${x},${y})`}>
    <rect x={-33} y={0} width={36} height={24} fill="#F8F9FA" />
  </g>
);

export function UsageBarLoadingState() {
  const data = [
    { name: "Category 1", value1: 20 },
    { name: "Category 2", value1: 40 },
    { name: "Category 3", value1: 15 },
    { name: "Category 4", value1: 20 },
    { name: "Category 5", value1: 40 },
    { name: "Category 6", value1: 15 },
    { name: "Category 7", value1: 20 },
    { name: "Category 8", value1: 40 },
    { name: "Category 9", value1: 15 },
    { name: "Category 10", value1: 20 },
    { name: "Category 11", value1: 40 },
    { name: "Category 12", value1: 15 },
    { name: "Category 13", value1: 20 },
    { name: "Category 14", value1: 40 },
    { name: "Category 15", value1: 15 },
    { name: "Category 16", value1: 20 },
    { name: "Category 17", value1: 40 },
    { name: "Category 18", value1: 15 },
    { name: "Category 19", value1: 20 },
    { name: "Category 20", value1: 40 },
    { name: "Category 21", value1: 15 },
  ];
return (
  <div style={{width:"50%", background:"#fff"}}>
     <ResponsiveContainer width={"100%"} height={300}>
              <BarChart
                barSize={36}
                data={data}
                margin={{ top: 20, right: 30, left: 20, bottom: 30 }}
              >
                <CartesianGrid
                  strokeDasharray="0"
                  stroke="var(--Neutral-D9, #F8F9FA) "
                />
                <XAxis dataKey="name" hide />
                <YAxis
                  stroke="var(--Neutral-D9, #F8F9FA)"
                  tick={<CustomYAxisTick />}
                />

                <Bar dataKey="value1" fill="#F8F9FA" animation="glow"></Bar>
              </BarChart>
            </ResponsiveContainer>
  </div>
)
}
export function UsagePieChartLoadingState() {
  return (
    <div style={{background:"#fff", width:"50%"}}>
      <ResponsiveContainer width={"50%"} height={255} style={{display:"flex"}}>

            <Placeholder
              className={styles.placeholder_css}
              xs={2}
              style={{ height: "244px", width: "228px", borderRadius: "50%", marginBottom: "12px" }}
            />


            <div style={{display:"flex", alignItems:"center" , paddingLeft:"30px"}}>
        
            <Row style={{display:"flex", gap:"16px"}}>
              <Col xs={5}
                style={{
                  display: "flex",
                  marginRight: "132px",
                  gap:"16px"
                }}
              >
                <Placeholder
                  className={styles.placeholder_css}
                  style={{ height: "15px", width: "40px", borderRadius:"2px" }}
                />
                <Placeholder
                  className={styles.placeholder_css}
                  style={{ height: "15px", width: "324px", borderRadius:"2px"  }}
                />
                <Placeholder
                  className={styles.placeholder_css}
                  style={{ height: "15px", width: "100px", borderRadius:"2px"  }}
                />
              </Col>
              <Col xs={5}
                style={{
                  display: "flex",
                  marginRight: "132px",
                  gap:"16px"
                }}
              >
                <Placeholder
                  className={styles.placeholder_css}
                  style={{ height: "15px", width: "40px", borderRadius:"2px" }}
                />
                <Placeholder
                  className={styles.placeholder_css}
                  style={{ height: "15px", width: "324px", borderRadius:"2px"  }}
                />
                <Placeholder
                  className={styles.placeholder_css}
                  style={{ height: "15px", width: "100px", borderRadius:"2px"  }}
                />
              </Col>
              <Col xs={5}
                style={{
                  display: "flex",
                  marginRight: "132px",
                  gap:"16px"
                }}
              >
                <Placeholder
                  className={styles.placeholder_css}
                  style={{ height: "15px", width: "40px", borderRadius:"2px" }}
                />
                <Placeholder
                  className={styles.placeholder_css}
                  style={{ height: "15px", width: "324px", borderRadius:"2px"  }}
                />
                <Placeholder
                  className={styles.placeholder_css}
                  style={{ height: "15px", width: "100px", borderRadius:"2px"  }}
                />
              </Col>
              <Col xs={5}
                style={{
                  display: "flex",
                  marginRight: "132px",
                  gap:"16px"
                }}
              >
                <Placeholder
                  className={styles.placeholder_css}
                  style={{ height: "15px", width: "40px", borderRadius:"2px" }}
                />
                <Placeholder
                  className={styles.placeholder_css}
                  style={{ height: "15px", width: "324px", borderRadius:"2px"  }}
                />
                <Placeholder
                  className={styles.placeholder_css}
                  style={{ height: "15px", width: "100px", borderRadius:"2px"  }}
                />
              </Col>
          
            </Row>


            </div>

           
              
            </ResponsiveContainer>
    </div>
  )
}
